import { PAGE_TYPE } from "./constants";

/**
 * Known default pages that have explicit route definitions
 * Only these slugs should use slug-based route names like "pages.{slug}"
 */
const KNOWN_DEFAULT_PAGES = new Set([
  "accommodations",
  "events",
  "faq",
  "guest-book",
  "home",
  "photos",
  "registry",
  "rsvp",
  "wedding-party",
]);

export const buildRouteArgs = (page) => {
  const isKnownDefaultPage =
    page.data.isDefault && KNOWN_DEFAULT_PAGES.has(page.data.slug);

  return {
    name: isKnownDefaultPage ? `pages.${page.data.slug}` : "pages.custom",
    params: isKnownDefaultPage
      ? {}
      : {
          id: `${page.data.id}`,
          slug: page.data.slug,
        },
  };
};

export const getPageType = (defaultName) => {
  switch (defaultName) {
    case "Events":
      return PAGE_TYPE.EVENTS;
    case "Gift Registry":
      return PAGE_TYPE.GIFT_REGISTRY;
    case "Home":
      return PAGE_TYPE.HOME;
    case "Gallery":
      return PAGE_TYPE.GALLERY;
    case "RSVP":
      return PAGE_TYPE.RSVP;
    case "Wedding Party":
      return PAGE_TYPE.PARTY;
    case "Guest Book":
      return PAGE_TYPE.GUEST_BOOK;
  }

  return PAGE_TYPE.OTHER;
};
